import Swiper from 'swiper';
// core version + navigation, pagination modules:
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper/core';
// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination, Autoplay]);

export default () => {
	const testimonialsSwiper = new Swiper('.testimonials-section-slider-sidebar', {
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		autoHeight: true,
		a11y: true,
		keyboardControl: true,
		grabCursor: true,
		slidesPerView: 1,
		watchOverflow: true,
		autoplay: {
			delay: 30000,
		}
	});

	//  listen for browser size changes 
	window.onresize = function () {
		testimonialsSwiper.update();
	}
};